import axios from 'axios';
import * as qs from 'qs';
import { ICrudDeleteAction, ICrudGetAction, ICrudPutAction } from 'react-jhipster';

import { cleanEntity } from 'app/shared/util/entity-utils';
import { FAILURE, REQUEST, SUCCESS } from 'app/shared/reducers/action-type.util';

import { defaultValue, IMessageTemplate } from 'app/shared/model/message-template.model';
import { ICrudGetListAction } from 'app/shared/model/list';
import { flattenKey } from 'app/shared/util/object-utils';
// 请求
export const ACTION_TYPES = {
  FETCH_MESSAGETEMPLATE_LIST: 'messageTemplate/FETCH_MESSAGETEMPLATE_LIST',
  LOAD_MESSAGETEMPLATE_LIST: 'messageTemplate/LOAD_MESSAGETEMPLATE_LIST',
  FETCH_MESSAGETEMPLATE: 'messageTemplate/FETCH_MESSAGETEMPLATE',
  CREATE_MESSAGETEMPLATE: 'messageTemplate/CREATE_MESSAGETEMPLATE',
  UPDATE_MESSAGETEMPLATE: 'messageTemplate/UPDATE_MESSAGETEMPLATE',
  DELETE_MESSAGETEMPLATE: 'messageTemplate/DELETE_MESSAGETEMPLATE',
  RESET: 'messageTemplate/RESET'
};
// state
const initialState = {
  loading: false,
  fetching: false,
  loadMore: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IMessageTemplate>,
  entity: defaultValue,
  updating: false,
  updateSuccess: false,
  totalItems: 0
};

export type MessageTemplateState = Readonly<typeof initialState>;

// Reducer

export default (state: MessageTemplateState = initialState, action): MessageTemplateState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_MESSAGETEMPLATE_LIST):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
        fetching: true
      };
    case REQUEST(ACTION_TYPES.LOAD_MESSAGETEMPLATE_LIST):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loadMore: true
      };
    case REQUEST(ACTION_TYPES.FETCH_MESSAGETEMPLATE):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true
      };
    case REQUEST(ACTION_TYPES.CREATE_MESSAGETEMPLATE):
    case REQUEST(ACTION_TYPES.UPDATE_MESSAGETEMPLATE):
    case REQUEST(ACTION_TYPES.DELETE_MESSAGETEMPLATE):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true
      };
    case FAILURE(ACTION_TYPES.FETCH_MESSAGETEMPLATE_LIST):
    case FAILURE(ACTION_TYPES.LOAD_MESSAGETEMPLATE_LIST):
    case FAILURE(ACTION_TYPES.FETCH_MESSAGETEMPLATE):
    case FAILURE(ACTION_TYPES.CREATE_MESSAGETEMPLATE):
    case FAILURE(ACTION_TYPES.UPDATE_MESSAGETEMPLATE):
    case FAILURE(ACTION_TYPES.DELETE_MESSAGETEMPLATE):
      return {
        ...state,
        loading: false,
        fetching: false,
        loadMore: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload
      };
    case SUCCESS(ACTION_TYPES.FETCH_MESSAGETEMPLATE_LIST):
      return {
        ...state,
        loading: false,
        fetching: false,
        entities: action.payload.data,
        totalItems: parseInt(action.payload.headers['x-total-count'], 10)
      };
    case SUCCESS(ACTION_TYPES.LOAD_MESSAGETEMPLATE_LIST):
      return {
        ...state,
        loadMore: false,
        entities: state.entities.concat(action.payload.data),
        totalItems: parseInt(action.payload.headers['x-total-count'], 10)
      };
    case SUCCESS(ACTION_TYPES.FETCH_MESSAGETEMPLATE):
      return {
        ...state,
        loading: false,
        entity: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.CREATE_MESSAGETEMPLATE):
    case SUCCESS(ACTION_TYPES.UPDATE_MESSAGETEMPLATE):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.DELETE_MESSAGETEMPLATE):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {}
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState
      };
    default:
      return state;
  }
};

const apiUrl = 'api/message-templates'; // 群发通知-消息模板

// Actions
// 消息模板列表
export const getEntities: ICrudGetListAction<IMessageTemplate[]> = (page, size, sort, searchForm) => {
  const requestUrl = `${apiUrl}${sort ? `?page=${page}&size=${size}&sort=${sort}` : ''}`;
  return {
    type: ACTION_TYPES.FETCH_MESSAGETEMPLATE_LIST,
    payload: axios.get<IMessageTemplate[]>(`${requestUrl}${sort ? '&' : '?'}cacheBuster=${new Date().getTime()}`, {
      params: flattenKey(searchForm),
      paramsSerializer: params => qs.stringify(params, { arrayFormat: 'indices' })
    }),
    meta: { transformUserName: true }
  };
};

export const loadEntities: ICrudGetListAction<IMessageTemplate[]> = (page, size, sort, searchForm) => {
  const requestUrl = `${apiUrl}${sort ? `?page=${page}&size=${size}&sort=${sort}` : ''}`;
  return {
    type: ACTION_TYPES.LOAD_MESSAGETEMPLATE_LIST,
    payload: axios.get<IMessageTemplate[]>(`${requestUrl}${sort ? '&' : '?'}cacheBuster=${new Date().getTime()}`, {
      params: flattenKey(searchForm),
      paramsSerializer: params => qs.stringify(params, { arrayFormat: 'indices' })
    }),
    meta: { transformUserName: true }
  };
};
// 消息模板详情
export const getEntity: ICrudGetAction<IMessageTemplate> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_MESSAGETEMPLATE,
    payload: axios.get<IMessageTemplate>(requestUrl)
  };
};
// 创建消息模板
export const createEntity: ICrudPutAction<IMessageTemplate> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_MESSAGETEMPLATE,
    payload: axios.post(apiUrl, cleanEntity(entity))
  });
  dispatch(getEntities());
  return result;
};
// 更新消息模板
export const updateEntity: ICrudPutAction<IMessageTemplate> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_MESSAGETEMPLATE,
    payload: axios.put(apiUrl, cleanEntity(entity))
  });
  dispatch(getEntities());
  return result;
};
// 删除消息模板
export const deleteEntity: ICrudDeleteAction<IMessageTemplate> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_MESSAGETEMPLATE,
    payload: axios.delete(requestUrl)
  });
  dispatch(getEntities());
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET
});
